import { Component, Vue, Watch } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';

import ToolbarAction from '@/../bower_components/teknisavuecomponents/assets/interfaces/ToolbarAction';
import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import EditableTableColumn from '@/../bower_components/teknisavuecomponents/assets/interfaces/EditableTableColumn';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import QuadroGeralVinculoController from '@/assets/ts/controller/QuadroGeralVinculoController';
import Estrutura from '@/../bower_components/teknisavuecomponents/assets/interfaces/Estrutura';
import Periodo from '@/../bower_components/teknisavuecomponents/assets/interfaces/Periodo';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import PopupController from '@/assets/ts/controller/PopupController';
import DocumentosController from '@/assets/ts/controller/DocumentosController';
import QrCodeController from '@/assets/ts/controller/QrCodeController';
import DialogUtils from '@/../bower_components/teknisavuecomponents/assets/utils/DialogUtils';

@Component({
  name: 'QuadroGeralVinculo',
  components: {
    EditableTable,
  },
})
class QuadroGeralVinculo extends Vue {
  // #region [ STORE ]
  private get periodoDemonstrativoAtual(): Periodo {
    return this.$store.getters.periodoDemonstrativoAtual;
  }

  private get estruturaGerencialAtual(): Estrutura {
    return this.$store.getters.estruturaGerencialAtual;
  }

  @Mutation('changeCurrentView')
  private changeCurrentView: (string) => void;
  // #endregion

  // #region [ DATA ]
  private readonly viewTitle = 'Quadro Geral dos Vínculos';

  private quadroGeralVinculo: any[] = [];

  private loading = false;

  private vinculosQrCodes  = [] ;

  private gridSelected = [];

  private toolbarQrCodeActionName = 'qrcode';

  private toolbarAdditionalActions = [
    {
      name: this.toolbarQrCodeActionName,
      icon: 'mdi-qrcode',
      label: 'Gravar Imagem QR Codes',
      showLabel: true,
      disabled: true,
      onClick: this.salvarQrCodes,
    },
  ];

  private actions = [
    {
      name: 'view',
      label: 'Detalhes',
      icon: 'mdi-eye',
      onClick: this.visualizarActionOnClick,
      mode: 'view',
    },
  ];

  private columns: EditableTableColumn[] = [
    {
      text: 'Nr. Vínculo',
      value: 'NRVINCULOM',
      type: 'text',
    },
    {
      text: 'Nome',
      value: 'NMVINCULOM',
      type: 'text',
    },
    {
      text: 'Tipo de Vínculo',
      value: 'NMTIPOVINCULOH',
      type: 'text',
    },
    {
      text: 'Dt. Admissão',
      value: 'DTADMISSAOVINC',
      type: 'date',
    },
    {
      text: 'Situação Funcional',
      value: 'NMSITUFUNCH',
      type: 'text',
    },
    {
      text: 'Data Ult. Alt. Salário',
      value: 'DTALTESALARIO',
      type: 'date',
    },
    {
      text: 'Salário',
      value: 'VRSALARIO',
      type: 'number',
      align: 'right',
    },
    {
      text: 'Escala de Trabalho',
      value: 'NMESCALATRABH',
      type: 'text',
    },
    {
      text: 'Ocupação',
      value: 'NMOCUPACAOH',
      type: 'text',
    },
    {
      text: 'Existe QR Code?',
      value: 'EXISTE_QRCODE',
      type: 'text',
    },
  ];

  private toolbarActions: ToolbarAction[] = [
    {
      name: 'reload',
      label: 'Atualizar',
      icon: 'mdi-refresh',
      onClick: this.reload,
    },
  ];
  // #endregion

  // #region [ COMPUTED ]
  private get filtersAreSelected(): boolean {
    const areSelected =
      !Util.isUndefinedOrNull(this.estruturaGerencialAtual) &&
      !Util.isUndefinedOrNull(this.periodoDemonstrativoAtual);

    return areSelected;
  }
  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    this.changeCurrentView(this.viewTitle);
    (window as any).quadroGeralVinculo = this;
  }

  private mounted() {
    this.reload();
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('estruturaGerencialAtual')
  private estruturaOnChange() {
    this.reload();
  }

  @Watch('periodoDemonstrativoAtual')
  private periodoOnChange() {
    this.reload();
  }

  @Watch('gridSelected')
  private changeAction() {
    this.changeDisabledActions();
  }
  // #endregion

  // #region [ METHODS ]
  private async reload() {
    if (!this.verifyFilters()) {
      return;
    }

    this.loading = true;
    this.quadroGeralVinculo = [];

    try {
      const quadroGeralVinculo = await QuadroGeralVinculoController.getQuadroGeralVinculo(false);

      this.quadroGeralVinculo = quadroGeralVinculo;
    } catch (err) {
      let message = '';

      if ((err as any).name === 'ExpectedError') {
        message = (err as any).message;
        message = message.replace('(HCMSERVICES) ', '');
      } else {
        message = 'Não foi possível carregar os vínculos!';
      }

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
    } finally {
      this.loading = false;
    }
  }

  private verifyFilters(): boolean {
    if (this.filtersAreSelected) {
      return true;
    }

    const message = 'Selecione uma unidade e um período!';
    SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ALERT);

    return false;
  }

  private visualizarActionOnClick(row: any) {
    PopupController.openPopup('detalhesQuadroGeral', { nrVinculo: row.NRVINCULOM, nmVinculo: row.NMVINCULOM });
  }

  private changeDisabledActions() {
    const areAdditionalActionsDisabled = !this.gridSelected.length; 
    this.toolbarAdditionalActions.forEach((action) => {
      action.disabled = areAdditionalActionsDisabled;
    });
  }

  private async salvarQrCodes() {
    this.vinculosQrCodes = this.gridSelected;

    if (!this.vinculosQrCodes.length) {
      const message = 'Selecione pelo menos um vinculo!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ALERT);
      return
    }

    await DialogUtils.show('Gravar imagem QR Codes', 'Os QR Codes para registro de ponto serão gerados e armazenados para os colaboradores selecionados. Deseja continuar?');

    this.loading = true;
    const arrayRow = this.vinculosQrCodes.map(({ NRCPFPESSOA, NRVINCULOM }) => {
      const qrcode = QrCodeController.generateQRCode(NRCPFPESSOA);
      return {
        DSREFERENCIA: "QrCode",
        FILE: qrcode,
        NMANEXO: "cpf_qr_code.png",
        NRVINCULOM: NRVINCULOM,
      }
    });

    try {
      await DocumentosController.saveDocumentosQrCode(arrayRow, false);
      this.gridSelected = [];
      this.loading = false;

      const message = 'Os QrCodes foram salvos com sucesso!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_SUCCESS);

      await this.reload();
    } catch (error) {
      SnackbarUtils.showMessage('Erro ao salvar os QrCodes!', 'error');
    } finally {
      this.loading = false;
    }
  }

}

export default QuadroGeralVinculo;